const EasingValues = {
    Ease: {
        x1: 0.25, y1: 0.1, x2: 0.25, y2: 1.0,
    },
    EaseIn: {
        x1: 0.42, y1: 0.0, x2: 1.0, y2: 1.0,
    },
    EaseInOut: {
        x1: 0.42, y1: 0.0, x2: 0.58, y2: 1.0,
    },
    EaseOut: {
        x1: 0.0, y1: 0.0, x2: 0.58, y2: 1.0,
    },
    Linear: {
        x1: 0.0, y1: 0.0, x2: 1.0, y2: 1.0,
    },
    Practical: {
        x1: 0.3, y1: 0.15, x2: 0.5, y2: 1,
    },
    Expressive: {
        x1: 0.5, y1: 0.05, x2: 0.3, y2: 1,
    },
    Bounce: {
        x1: 0.5, y1: -0.4, x2: 0.55, y2: 1.4,
    },
};

export { EasingValues };
